import { CoreIcon } from '@autopass-web/mochi-icons';

import styles from './index.module.sass';

const Spinner = ({ theme = 'grey' }: { theme: string }) => {
  return (
    <div className={styles.spinner}>
      <CoreIcon className={styles[theme]} src="../../assets/icon_spin.svg" />
    </div>
  );
};

export default Spinner;
